import { TooltipWrapper } from '@/components/Bicester/TooltipWrapper';
import { BICESTER_FULL_DATE } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import React from 'react';
import { SUBSCRIBE_OPTION } from '../constants';

const PassTips: React.FC<any> = ({ rowData }) => {
  return (
    <TooltipWrapper
      placement="topEnd"
      tooltip={
        <div className="pass-tips-container">
          <div>预约日期 {dayjs(rowData?.date).format(BICESTER_FULL_DATE)}</div>
          {rowData?.pass?.option?.map((item) => {
            const optionId = Number(item?.option_id);
            const hasOption = [
              SUBSCRIBE_OPTION.PARKING,
              SUBSCRIBE_OPTION.LOUNGE,
              SUBSCRIBE_OPTION.SA,
            ].includes(optionId);
            return hasOption ? (
              <ul className="grid grid-cols-4" key={item?.option_id}>
                <li>{item?.option_name}</li>
                <li>{item?.time_slot}</li>
                <li>
                  {item?.option_id === SUBSCRIBE_OPTION.PARKING
                    ? item?.content
                    : `${item?.content}${optionId === SUBSCRIBE_OPTION.PARKING ? '' : '人'}`}
                </li>
                <li>上次通过</li>
              </ul>
            ) : (
              <div key={item?.option_id}>{item?.option_name}</div>
            );
          }) || []}
          <div>备注：{rowData?.pass?.remark || '/'}</div>
        </div>
      }
    >
      <span
        role="button"
        style={{
          color: rowData?.is_update_view === 1 ? '#E16F2C' : '#999999',
          borderBottom: rowData?.is_update_view === 1 ? '1px solid #E16F2C' : '1px solid #999999',
          paddingBottom: 2,
        }}
      >
        查看上次通过
      </span>
    </TooltipWrapper>
  );
};

export default PassTips;
